<div class="choose-dictionary-container h-100">
    <span class="fs-3">
        {{'admin.languages.dictionary.title' | translate}}
    </span>
    <span class="subtitle">
        {{'admin.languages.dictionary.subtitle' | translate}}
    </span>

    <div class="dropdown-item-container col-12 col-xl-9 col-xxl-6">
        <span class="input-label">{{'admin.languages.dictionary.selectDictionary' | translate}}<span class="text-primary fw-bold">*</span></span>
        <div class="input-dropdown-container">
            <kendo-combobox HJSuppress
                class="custom-kendo-control-xl" 
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                [size]="sizeLarge"
                name="dictionaryEntity"
                [placeholder]="'admin.languages.dictionary.chooseDictionary' | translate"
                [clearButton]="false"
                [data]="dictionariesDatasource"
                [textField]="'value'"
                [valueField]="'id'"
                [valuePrimitive]="true"
                [(ngModel)]="selectedDictionary"
                (ngModelChange)="handlerDictionarySelected($event)"
                #chooseDictionaryCmb
                (click)="!chooseDictionaryCmb.isOpen ? chooseDictionaryCmb.toggle() : null"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
            </kendo-combobox>
        </div>
    </div>

    <button class="btn primary-btn" 
        (click)="redirectChooseLanguage()" 
        [disabled]="!isDictionarySelected" 
    >
        {{'common.continue' | translate}}
    </button>
</div>